var _metadata, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluePhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1422,
    height: 1422,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata3023"
  }, "image/svg+xml")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 1424,
    width: 1424,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-90 709.4404907226564,713.3114624023438) ",
    fill: "#59A3CF",
    id: "path3017",
    d: "m1413.44048,1121.311442q0,27 -10,70.5q-10,43.5 -21,68.5q-21,50 -122,106q-94,51 -186,51q-27,0 -52.5,-3.5q-25.5,-3.5 -57.5,-12.5q-32,-9 -47.5,-14.5q-15.5,-5.5 -55.5,-20.5q-40,-15 -49,-18q-98,-35 -175,-83q-128,-79 -264.5,-215.5q-136.5,-136.5 -215.5,-264.5q-48,-77 -83,-175q-3,-9 -18,-49q-15,-40 -20.5,-55.5q-5.5,-15.5 -14.5,-47.5q-9,-32 -12.5,-57.5q-3.5,-25.5 -3.5,-52.5q0,-92 51,-186q56,-101 106,-122q25,-11 68.5,-21q43.5,-10 70.5,-10q14,0 21,3q18,6 53,76q11,19 30,54q19,35 35,63.5q16,28.5 31,53.5q3,4 17.5,25q14.5,21 21.5,35.5q7,14.5 7,28.5q0,20 -28.5,50q-28.5,30 -62,55q-33.5,25 -62,53q-28.5,28 -28.5,46q0,9 5,22.5q5,13.5 8.5,20.5q3.5,7 14,24q10.5,17 11.5,19q76,137 174,235q98,98 235,174q2,1 19,11.5q17,10.5 24,14q7,3.5 20.5,8.5q13.5,5 22.5,5q18,0 46,-28.5q28,-28.5 53,-62q25,-33.5 55,-62q30,-28.5 50,-28.5q14,0 28.5,7q14.5,7 35.5,21.5q21,14.5 25,17.5q25,15 53.5,31q28.5,16 63.5,35q35,19 54,30q70,35 76,53q3,7 3,21z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePhone);
export default __webpack_public_path__ + "static/media/blue-phone.20ad3843f43406792da2f7b7d31085a3.svg";
export { ForwardRef as ReactComponent };